import store from '@/store';
import Vue from 'vue';

const plugin = {
  /**
   * Configure the $notify property on each component.
   * It's only a shortcut for the commits in the store.
   * The snackbars are coded in the App.vue file and the commits
   * are for the notifications module in the store.
   *
   * @param {Object} Vue The vue instance.
   */
  install(Vue) {
    Vue.prototype.$notify = {
      error: (message, timeout) => {
        store.commit('notifications/error', { message, timeout })
      },
      success: (message, timeout) => {
        store.commit('notifications/success', { message, timeout })
      }
    }
  }
}

Vue.use(plugin)
